var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.Manual", function(octopusRepository, busy) {
    return {
      executionLocation: actionExecutionLocations.alwaysOnServer,
      canChooseRoles: false,
      canHaveChildren: function() { return false; },
      canBeChild: true,
      hasPackages: function(action) { return false; },

            summaryTemplateUrl: "areas/projects/actions/Octopus.Manual_summary.html",
            editTemplateUrl: "areas/projects/actions/Octopus.Manual_edit.html",
            editLink: function ($scope, element, action) {
                var isLoading = $scope.isLoading = busy.create();
                $scope.selectedTeams = [];
                $scope.onChange = function () {
                    action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"] = $scope.selectedTeams.reduce(function (prev, team) {
                        return (prev ? (prev + ',') : '') + team;
                    });
                };

                $scope.$watch(function () {
                    return action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"];
                }, function () {
                    $scope.selectedTeams = (action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"] || '').split(',');
                });

                isLoading.promise(octopusRepository.Teams.all().then(function (teams) {
                    $scope.teams = teams;
                }));
            }
        };
    });
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.Manual.js
// module id = 481
// module chunks = 1